/* Toggle lalebu-stuck class on scroll - homepage only */
(function() {
  function init() {
    var hc = document.getElementById('header-component');
    if (!hc || !hc.hasAttribute('transparent')) return;

    var threshold = 100;
    var isStuck = false;

    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      if (y > threshold && !isStuck) {
        isStuck = true;
        hc.classList.add('lalebu-stuck');
      } else if (y <= threshold && isStuck) {
        isStuck = false;
        hc.classList.remove('lalebu-stuck');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
